<template>
  <div class="popular-providers">
    <div v-if="popularProviders && popularProviders.length" class="popular-provider__list">
      <h4 class="mb-2 grey--text">Or select from the most popular in your area:</h4>
      <ul class="list--unstyled">
        <li v-for="provider in popularProviders">
          <add-provider-link
            :provider="provider"
            :service-types="[serviceType]"
            :decoration="false"
            class="blue--text text--accent-1"
          />
        </li>
      </ul>
    </div>
    <h5 v-else>Search to find and add your {{ serviceType && serviceType.name || '' }} provider</h5>
  </div>
</template>

<script>
  import AddProviderLink from '@/components/common/AddProviderLink'

  export default {
    props: ['popularProviders', 'serviceType'],
    components: {
      AddProviderLink
    }
  }
</script>



// WEBPACK FOOTER //
// frontend/src/components/recommendations/PopularProviders.vue